import Strings from '../../Strings';

// Grouping for SmartMeter SKU pickers, mirroring the backend's association
// classes: exact device_model match, same-device_type kit, cross-type kit,
// and no-device (accessory/membership/service) SKUs. Model comparisons are
// case-insensitive to match backend classification.

// modelTypes maps lower-cased vendor model names to device_type.
export function modelTypesFromDevices(devices) {
  const map = {};
  (devices || []).forEach(d => {
    if (d.device_model) map[d.device_model.toLowerCase()] = d.device_type;
  });
  return map;
}

export function groupSmartmeterSkuOptions(smartmeterSkus, deviceModel, deviceType, modelTypes, { includeNoDevice = false } = {}) {
  const model = (deviceModel || '').toLowerCase();
  const toOption = sku => ({ value: sku.sku, label: `${sku.sku} - ${sku.description}` });
  const exact = [];
  const sameType = [];
  const crossType = [];
  const noDevice = [];
  (smartmeterSkus || []).forEach(sku => {
    const models = sku.device_model || [];
    if (models.length === 0) {
      noDevice.push(sku);
    } else if (models.some(m => m.toLowerCase() === model)) {
      exact.push(sku);
    } else if (deviceType && models.some(m => modelTypes[m.toLowerCase()] === deviceType)) {
      sameType.push(sku);
    } else {
      crossType.push(sku);
    }
  });
  const groups = [];
  if (exact.length) groups.push({ label: Strings.formatString(Strings.shipping.smartmeterProposedSkusForModel, deviceModel), options: exact.map(toOption) });
  if (sameType.length) groups.push({ label: Strings.formatString(Strings.shipping.smartmeterOtherTypeKits, deviceType), options: sameType.map(toOption) });
  if (crossType.length) groups.push({ label: Strings.shipping.smartmeterDifferentDeviceKits, options: crossType.map(toOption) });
  if (includeNoDevice && noDevice.length) groups.push({ label: Strings.shipping.smartmeterAccessorySkus, options: noDevice.map(toOption) });
  return groups;
}
